<aside class="sidebar" aria-label="Menu principal">
  <div class="brand">
    <div class="brand-info" [class.d-none-desktop]="collapsed()">
      <img src="assets/logo_global.png" alt="GlobalParts" class="brand-logo">
      <!-- Container colorido: nome do usuário + seletor de empresa -->
      <div class="menu-empresa-seletor" [style.border-left-color]="empresa.cor"
        [style.background]="empresa.corClara(0.7)">
        <div class="menu-empresa-dot" [style.background]="empresa.cor"></div>
        <div class="menu-empresa-info">
          <strong class="brand-usuario" [title]="userName">{{ userName }}</strong>
          <!-- Dropdown customizado — permite quebra de linha no valor exibido -->
          <div class="menu-empresa-dropdown" (click)="toggleEmpresaDropdown($event)">
            <span class="menu-empresa-valor">{{ empresaTexto }}</span>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
          <div class="menu-empresa-lista" *ngIf="empresaDropdownAberto">
            <div *ngFor="let e of empresa.opcoes" class="menu-empresa-item"
              [class.ativo]="e.codEmp === empresa.selecionada"
              [style.background]="empresa.corClaraPorCodEmp(e.codEmp, 0.82)"
              [style.border-left]="'3px solid ' + empresa.corPorCodEmp(e.codEmp)"
              (click)="selecionarEmpresa(e.codEmp, $event)">
              {{ e.codEmp }} — {{ e.nomeFant || e.razaoAbrev }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="mobile-sair" (click)="sair()" [disabled]="loggingOut()" aria-label="Sair" title="Sair">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    </button>
    <button type="button" class="collapse-hamburger" (click)="toggleSidebar()"
      [attr.aria-label]="collapsed() ? 'Expandir menu' : 'Recolher menu'"
      [title]="collapsed() ? 'Expandir menu' : 'Recolher menu'">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </svg>
    </button>
  </div>

  <div class="menu-search-wrap" [class.d-none-desktop]="collapsed()">
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input type="text" class="menu-search-input" placeholder="Pesquisar..." [(ngModel)]="menuBusca">
    <button *ngIf="emBusca()" class="menu-search-clear" (click)="menuBusca = ''">✕</button>
  </div>

  <nav class="menu" #menuScroll>
    <div class="menu-loading" *ngIf="!permissoesCarregadas" role="status" aria-live="polite">
      <img class="menu-loading-logo" src="assets/global-parts-plane-loading.webp" width="100" height="73" alt="" aria-hidden="true">
      <span class="menu-loading-text" [class.d-none-desktop]="collapsed()">Carregando Menu</span>
    </div>

    <ng-container *ngIf="permissoesCarregadas">
    <button type="button" class="menu-link" [class.active]="activeView === 'home'" (click)="navigate('home')"
      title="Home">
      <span class="menu-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      </span>
      <span class="menu-label">Home</span>
    </button>

    <div class="menu-group" [class.expanded]="stockExpanded()" [style.order]="ordemGrupo('stock')"
      *ngIf="mostraGrupoViews(['gpl-transferencia','lista-produtos','fabricantes','duplicar-produto','gpl-edicaodeprodutos'], 'stock')">
      <button type="button" class="menu-link group-header"
        [class.active]="activeView === 'gpl-transferencia' && (collapsed() || !stockExpanded())" (click)="toggleStock()"
        title="Produtos">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            <line x1="12" y1="22.08" x2="12" y2="12" />
          </svg>
        </span>
        <span class="menu-label">Produtos</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub"
        *ngIf="mostraGrupoViews(['gpl-transferencia','lista-produtos','fabricantes','duplicar-produto','gpl-edicaodeprodutos'], 'stock')">
        <button *ngIf="mostraItemView('gpl-transferencia', stockExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('gpl-transferencia')" [attr.data-resource-id]="resourceId('gpl-transferencia')"
          [class.active]="activeView === 'gpl-transferencia'" (click)="navigate('gpl-transferencia')"
          title="Transferência de Local">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="16 3 21 8 16 13" />
              <line x1="21" y1="8" x2="9" y2="8" />
              <polyline points="8 21 3 16 8 11" />
              <line x1="3" y1="16" x2="15" y2="16" />
            </svg>
          </span>
          <span class="menu-label">Transferência de Local</span>
        </button>

        <button *ngIf="mostraItemView('lista-produtos', stockExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('lista-produtos')" [attr.data-resource-id]="resourceId('lista-produtos')"
          [class.active]="activeView === 'lista-produtos'" (click)="navigate('lista-produtos')"
          title="Lista de Produtos">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
          </span>
          <span class="menu-label">Lista de Produtos</span>
        </button>

        <button *ngIf="mostraItemView('fabricantes', stockExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('fabricantes')" [attr.data-resource-id]="resourceId('fabricantes')"
          [class.active]="activeView === 'fabricantes'" (click)="navigate('fabricantes')" title="Fabricantes">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>
              <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/>
            </svg>
          </span>
          <span class="menu-label">Fabricantes</span>
        </button>

        <button *ngIf="mostraItemView('duplicar-produto', stockExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('duplicar-produto')" [attr.data-resource-id]="resourceId('duplicar-produto')"
          [class.active]="activeView === 'duplicar-produto'" (click)="navigate('duplicar-produto')" title="Cadastrar">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          </span>
          <span class="menu-label">Cadastrar</span>
        </button>

        <button *ngIf="mostraItemView('gpl-edicaodeprodutos', stockExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('gpl-edicaodeprodutos')" [attr.data-resource-id]="resourceId('gpl-edicaodeprodutos')"
          [class.active]="activeView === 'gpl-edicaodeprodutos'" (click)="navigate('gpl-edicaodeprodutos')"
          title="Edição/Cotação">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
            </svg>
          </span>
          <span class="menu-label">Edição/Cotação</span>
        </button>
      </div>
    </div>

    <div class="menu-group" [class.expanded]="aeronavesExpanded()" [style.order]="ordemGrupo('aeronaves')"
      *ngIf="mostraGrupoViews(['cadastro-aeronave'], 'aeronaves')">
      <button type="button" class="menu-link group-header" (click)="toggleAeronaves()" title="Aeronaves">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L14 19v-5.5l8 2.5z"></path>
          </svg>
        </span>
        <span class="menu-label">Aeronaves</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupoViews(['cadastro-aeronave'], 'aeronaves')">
        <button *ngIf="mostraItemView('cadastro-aeronave', aeronavesExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('cadastro-aeronave')"
          [attr.data-resource-id]="resourceId('cadastro-aeronave')" [class.active]="activeView === 'cadastro-aeronave'"
          (click)="navigate('cadastro-aeronave')" title="Cadastro de Aeronaves">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L14 19v-5.5l8 2.5z"></path>
              <line x1="18" y1="2" x2="18" y2="8"></line>
              <line x1="15" y1="5" x2="21" y2="5"></line>
            </svg>
          </span>
          <span class="menu-label">Cadastro</span>
        </button>
      </div>
    </div>

    <div class="menu-group" [class.expanded]="parceirosExpanded()" [style.order]="ordemGrupo('parceiros')"
      *ngIf="mostraGrupoViews(['cadastro-parceiro'], 'parceiros')">
      <button type="button" class="menu-link group-header" (click)="toggleParceiros()" title="Parceiros">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </span>
        <span class="menu-label">Parceiros</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupoViews(['cadastro-parceiro'], 'parceiros')">
        <button *ngIf="mostraItemView('cadastro-parceiro', parceirosExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('cadastro-parceiro')"
          [attr.data-resource-id]="resourceId('cadastro-parceiro')" [class.active]="activeView === 'cadastro-parceiro'"
          (click)="navigate('cadastro-parceiro')" title="Cadastro de Parceiros">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="20" y1="8" x2="20" y2="14"></line>
              <line x1="23" y1="11" x2="17" y2="11"></line>
            </svg>
          </span>
          <span class="menu-label">Cadastro</span>
        </button>
      </div>
    </div>

    <!-- ── MENU COMPRAS ── -->
    <div class="menu-group" [class.expanded]="comprasExpanded()" [style.order]="ordemGrupo('compras')"
      *ngIf="mostraGrupoViews(['pedido-compra', 'pre-compra-lista', 'compra-lista', 'consultar-ipi', 'download-xml-compra'], 'compras')">
      <button type="button" class="menu-link group-header"
        [class.active]="(activeView === 'pedido-compra' || activeView === 'pre-compra-lista' || activeView === 'compra-lista' || activeView === 'consultar-ipi' || activeView === 'download-xml-compra') && (collapsed() || !comprasExpanded())" (click)="toggleCompras()"
        title="Compras">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
        </span>
        <span class="menu-label">Compras</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupoViews(['pedido-compra', 'pre-compra-lista', 'compra-lista', 'consultar-ipi', 'download-xml-compra'], 'compras')">
        <button *ngIf="mostraItemView('pedido-compra', comprasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('pedido-compra')" [attr.data-resource-id]="resourceId('pedido-compra')"
          [class.active]="activeView === 'pedido-compra'" (click)="navigate('pedido-compra')" title="Pedido de Compra">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </span>
          <span class="menu-label">Pedido de Compra</span>
        </button>
        <button *ngIf="mostraItemView('pre-compra-lista', comprasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('pre-compra-lista')" [attr.data-resource-id]="resourceId('pre-compra-lista')"
          [class.active]="activeView === 'pre-compra-lista'" (click)="navigate('pre-compra-lista')" title="Pré-Compra">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="12" y1="11" x2="12" y2="17" />
              <line x1="9" y1="14" x2="15" y2="14" />
            </svg>
          </span>
          <span class="menu-label">Pré-Compra</span>
        </button>
        <button *ngIf="mostraItemView('compra-lista', comprasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('compra-lista')" [attr.data-resource-id]="resourceId('compra-lista')"
          [class.active]="activeView === 'compra-lista'" (click)="navigate('compra-lista')" title="Compra">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
          </span>
          <span class="menu-label">Compra</span>
        </button>
        <button *ngIf="mostraItemView('consultar-ipi', comprasExpanded())" type="button" class="menu-link sub-link"
                [style.order]="ordemItem('consultar-ipi')" [attr.data-resource-id]="resourceId('consultar-ipi')"
                [class.active]="activeView === 'consultar-ipi'" (click)="navigate('consultar-ipi')" title="Consultar IPI">
          <span class="menu-icon sub-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 19 19 5"/><circle cx="7" cy="7" r="3"/><circle cx="17" cy="17" r="3"/></svg></span>
          <span class="menu-label">Consultar IPI</span>
        </button>
        <button *ngIf="mostraItemView('download-xml-compra', comprasExpanded())" type="button" class="menu-link sub-link"
                [style.order]="ordemItem('download-xml-compra')" [attr.data-resource-id]="resourceId('download-xml-compra')"
                [class.active]="activeView === 'download-xml-compra'" (click)="navigate('download-xml-compra')" title="Download XML Compra">
          <span class="menu-icon sub-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg></span>
          <span class="menu-label">Download XML Compra</span>
        </button>
      </div>
    </div>

    <!-- ── MENU ESTOQUE ── -->
    <div class="menu-group" [class.expanded]="estoqueExpanded()"
      *ngIf="!emBusca() || mostraGrupo(['Separação de Estoque', 'Logística de Estoque', 'Conf. Pendente Vendedor', 'Itens Pendentes', 'Comparação de Estoque', 'Controle de Core', 'Controle de Forms'])">
      <button type="button" class="menu-link group-header"
        [class.active]="activeView === 'estoque-separacao' && (collapsed() || !estoqueExpanded())"
        (click)="toggleEstoque()" title="Estoque">
        <span class="menu-icon">
          <!-- Ícone para Estoque, usando box -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
            </path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
          </svg>
        </span>
        <span class="menu-label">Estoque</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub"
        *ngIf="mostraGrupo(['Separação de Estoque', 'Conferência de Estoque', 'Logística de Estoque', 'Painel de Conferência', 'Conf. Pendente Vendedor', 'Itens Pendentes', 'Comparação de Estoque', 'Controle de Core', 'Controle de Forms'])">
        <button *ngIf="mostraItem('Separação de Estoque', estoqueExpanded())" type="button" class="menu-link sub-link"
          [class.active]="activeView === 'estoque-separacao'" (click)="navigate('estoque-separacao')"
          title="Separação de Estoque">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </span>
          <span class="menu-label">Separação de Estoque</span>
        </button>
        <button *ngIf="mostraItemView('estoque-conferencia', estoqueExpanded())" type="button"
          class="menu-link sub-link"
          [class.active]="activeView === 'estoque-conferencia' || activeView === 'estoque-conferencia-itens'"
          (click)="navigate('estoque-conferencia')" title="Conferência de Estoque">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 11 12 14 22 4"></polyline>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          </span>
          <span class="menu-label">Conferência de Estoque</span>
        </button>
        <button *ngIf="mostraItemView('estoque-logistica', estoqueExpanded())" type="button" class="menu-link sub-link"
          [class.active]="activeView === 'estoque-logistica' || activeView === 'estoque-logistica-itens'"
          (click)="navigate('estoque-logistica')" title="Logística de Estoque">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="1" />
              <path d="M16 8h4l3 4v4h-7V8z" />
              <circle cx="5.5" cy="18.5" r="2.5" />
              <circle cx="18.5" cy="18.5" r="2.5" />
            </svg>
          </span>
          <span class="menu-label">Logística de Estoque</span>
        </button>
        <button *ngIf="mostraItemView('conferencia-pendente', estoqueExpanded())" type="button"
          class="menu-link sub-link"
          [class.active]="activeView === 'conferencia-pendente' || activeView === 'conferencia-pendente-itens'"
          (click)="navigate('conferencia-pendente')" title="Conf. Pendente Vendedor">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </span>
          <span class="menu-label">Conf. Pendente Vendedor</span>
        </button>
        <button *ngIf="mostraItemView('itens-pendentes-legado', estoqueExpanded())" type="button"
          class="menu-link sub-link"
          [class.active]="activeView === 'itens-pendentes-legado'"
          (click)="navigate('itens-pendentes-legado')" title="Itens Pendentes">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="1" />
              <path d="M16 8h4l3 4v4h-7V8z" />
              <circle cx="5.5" cy="18.5" r="2.5" />
              <circle cx="18.5" cy="18.5" r="2.5" />
            </svg>
          </span>
          <span class="menu-label">Itens Pendentes</span>
        </button>
        <button *ngIf="mostraItemView('comparacao-estoque', estoqueExpanded())" type="button"
          class="menu-link sub-link"
          [class.active]="activeView === 'comparacao-estoque'"
          (click)="navigate('comparacao-estoque')" title="Comparação de Estoque">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 3v18h18"></path>
              <path d="M18 17V9"></path>
              <path d="M13 17V5"></path>
              <path d="M8 17v-3"></path>
            </svg>
          </span>
          <span class="menu-label">Comparação de Estoque</span>
        </button>
        <button *ngIf="mostraItemView('controle-core', estoqueExpanded())" type="button"
          class="menu-link sub-link" [attr.data-resource-id]="resourceId('controle-core')"
          [class.active]="activeView === 'controle-core'" (click)="navigate('controle-core')"
          title="Controle de Core">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48 2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48 2.83-2.83" />
              <circle cx="12" cy="12" r="4" />
            </svg>
          </span>
          <span class="menu-label">Controle de Core</span>
        </button>
        <button *ngIf="mostraItemView('controle-forms', estoqueExpanded())" type="button"
          class="menu-link sub-link" [attr.data-resource-id]="resourceId('controle-forms')"
          [class.active]="activeView === 'controle-forms'" (click)="navigate('controle-forms')"
          title="Controle de Forms">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6M8 13h8M8 17h8" />
            </svg>
          </span>
          <span class="menu-label">Controle de Forms</span>
        </button>
      </div>
    </div>
    <div class="menu-group" [class.expanded]="vendasExpanded()" [style.order]="ordemGrupo('vendas')"
      *ngIf="mostraGrupoViews(['pedido-venda-lista','pre-venda-lista','liberacao'], 'vendas')">
      <button type="button" class="menu-link group-header" (click)="toggleVendas()" title="Vendas">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
          </svg>
        </span>
        <span class="menu-label">Vendas</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupoViews(['pedido-venda-lista','pre-venda-lista','liberacao'], 'vendas')">
        <button *ngIf="mostraItemView('pedido-venda-lista', vendasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('pedido-venda-lista')" [attr.data-resource-id]="resourceId('pedido-venda-lista')"
          [class.active]="activeView === 'pedido-venda-lista' || activeView === 'pedido-venda'"
          (click)="navigate('pedido-venda-lista')" title="Pedido de Venda">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </span>
          <span class="menu-label">Pedido de Venda</span>
        </button>
        <button *ngIf="mostraItemView('pre-venda-lista', vendasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('pre-venda-lista')" [attr.data-resource-id]="resourceId('pre-venda-lista')"
          [class.active]="activeView === 'pre-venda-lista' || activeView === 'pre-venda'"
          (click)="navigate('pre-venda-lista')" title="Pré-Venda">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </span>
          <span class="menu-label">Pré-Venda</span>
        </button>
        <button *ngIf="mostraItemView('liberacao', vendasExpanded())" type="button" class="menu-link sub-link"
          [style.order]="ordemItem('liberacao')" [attr.data-resource-id]="resourceId('liberacao')"
          [class.active]="activeView === 'liberacao'" (click)="navigate('liberacao')" title="Liberações">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </span>
          <span class="menu-label">Liberações</span>
        </button>
      </div>
    </div>
    <div class="menu-group" [class.expanded]="parametrizacaoExpanded()" [style.order]="ordemGrupo('parametrizacao')"
      *ngIf="mostraGrupoViews(['gpl-regras-comissao','motivo-cancelamento','etiqueta-config','gpl-parametros','controle-acessos','atividade-acessos','nota-control-teste'], 'parametrizacao')">
      <button type="button" class="menu-link group-header"
        [class.active]="(activeView === 'gpl-regras-comissao' || activeView === 'motivo-cancelamento' || activeView === 'etiqueta-config' || activeView === 'gpl-parametros' || activeView === 'controle-acessos' || activeView === 'atividade-acessos' || activeView === 'nota-control-teste') && (collapsed() || !parametrizacaoExpanded())"
        (click)="toggleParametrizacao()" title="Parametrização">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="21" x2="14" y1="4" y2="4" />
            <line x1="10" x2="3" y1="4" y2="4" />
            <line x1="21" x2="12" y1="12" y2="12" />
            <line x1="8" x2="3" y1="12" y2="12" />
            <line x1="21" x2="16" y1="20" y2="20" />
            <line x1="12" x2="3" y1="20" y2="20" />
            <line x1="14" x2="14" y1="2" y2="6" />
            <line x1="8" x2="8" y1="10" y2="14" />
            <line x1="16" x2="16" y1="18" y2="22" />
          </svg>
        </span>
        <span class="menu-label">Parametrização</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub"
        *ngIf="mostraGrupoViews(['gpl-regras-comissao','motivo-cancelamento','etiqueta-config','gpl-parametros','controle-acessos','atividade-acessos','nota-control-teste'], 'parametrizacao')">
        <button *ngIf="mostraItemView('gpl-regras-comissao', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-regras-comissao')"
          [attr.data-resource-id]="resourceId('gpl-regras-comissao')"
          [class.active]="activeView === 'gpl-regras-comissao'" (click)="navigate('gpl-regras-comissao')"
          title="Regras de Comissão">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </span>
          <span class="menu-label">Regras de Comissão</span>
        </button>

        <button *ngIf="mostraItemView('motivo-cancelamento', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('motivo-cancelamento')"
          [attr.data-resource-id]="resourceId('motivo-cancelamento')"
          [class.active]="activeView === 'motivo-cancelamento'" (click)="navigate('motivo-cancelamento')"
          title="Motivos de Cancelamento">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </span>
          <span class="menu-label">Motivos de Cancelamento</span>
        </button>

        <button *ngIf="mostraItemView('etiqueta-config', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('etiqueta-config')"
          [attr.data-resource-id]="resourceId('etiqueta-config')" [class.active]="activeView === 'etiqueta-config'"
          (click)="navigate('etiqueta-config')" title="Configuração de Etiquetas">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" />
              <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
              <line x1="12" y1="12" x2="12" y2="16" />
              <line x1="10" y1="14" x2="14" y2="14" />
            </svg>
          </span>
          <span class="menu-label">Configuração de Etiquetas</span>
        </button>

        <button *ngIf="mostraItemView('gpl-parametros', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-parametros')"
          [attr.data-resource-id]="resourceId('gpl-parametros')" [class.active]="activeView === 'gpl-parametros'"
          (click)="navigate('gpl-parametros')" title="Parâmetros do Sistema">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </span>
          <span class="menu-label">Parâmetros do Sistema</span>
        </button>

        <button *ngIf="mostraItemView('controle-acessos', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('controle-acessos')"
          [attr.data-resource-id]="resourceId('controle-acessos')" [class.active]="activeView === 'controle-acessos'"
          (click)="navigate('controle-acessos')" title="Controle de Acessos">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="10" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </span>
          <span class="menu-label">Controle de Acessos</span>
        </button>

        <button *ngIf="mostraItemView('atividade-acessos', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('atividade-acessos')"
          [attr.data-resource-id]="resourceId('atividade-acessos')" [class.active]="activeView === 'atividade-acessos'"
          (click)="navigate('atividade-acessos')" title="Atividade de Acessos">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M16 11l2 2 4-4" />
            </svg>
          </span>
          <span class="menu-label">Atividade de Acessos</span>
        </button>

        <!-- NFS-e (Teste Nota Control) -- oculta do menu por enquanto, a
             pedido do usuário ("não vamos usar ela"). Forçado com `false &&`
             em vez de remover o botão pra não perder o markup; a tela/rota
             continuam existindo normalmente. Pra reativar, tire o `false &&`. -->
        <button *ngIf="false && mostraItemView('nota-control-teste', parametrizacaoExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('nota-control-teste')"
          [attr.data-resource-id]="resourceId('nota-control-teste')" [class.active]="activeView === 'nota-control-teste'"
          (click)="navigate('nota-control-teste')" title="NFS-e (Teste Nota Control)">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 2h11l5 5v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
              <polyline points="15 2 15 7 20 7" />
              <path d="M8 13l2 2 4-5" />
            </svg>
          </span>
          <span class="menu-label">NFS-e (Teste Nota Control)</span>
        </button>
      </div>
    </div>

    <div class="menu-group" [class.expanded]="financeiroExpanded()" [style.order]="ordemGrupo('financeiro')"
      *ngIf="mostraGrupoViews(['contas', 'gpl-holerites'], 'financeiro')">
      <button type="button" class="menu-link group-header"
        [class.active]="(activeView === 'contas' || activeView === 'gpl-holerites') && (collapsed() || !financeiroExpanded())"
        (click)="toggleFinanceiro()" title="Financeiro">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <path d="M2 10h20M6 15h3" />
          </svg>
        </span>
        <span class="menu-label">Financeiro</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupoViews(['contas', 'gpl-holerites'], 'financeiro')">
        <button *ngIf="mostraItemView('contas', financeiroExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('contas')"
          [attr.data-resource-id]="resourceId('contas')" [class.active]="activeView === 'contas'"
          (click)="navigate('contas')" title="Contas">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 10h18M7 15h3" />
            </svg>
          </span>
          <span class="menu-label">Contas</span>
        </button>
        <button *ngIf="mostraItemView('gpl-holerites', financeiroExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-holerites')"
          [attr.data-resource-id]="resourceId('gpl-holerites')" [class.active]="activeView === 'gpl-holerites'"
          (click)="navigate('gpl-holerites')" title="Demonstrativos de Pagamento (Holerites)">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6M8 13h8M8 17h6" />
            </svg>
          </span>
          <span class="menu-label">Demonstrativos de Pagamento (Holerites)</span>
        </button>
      </div>
    </div>

    <div class="menu-group" [class.expanded]="reportsExpanded()" [style.order]="ordemGrupo('reports')"
      *ngIf="mostraGrupoViews(['demonstrativo-vendas','gpl-conferencia-cliente','gpl-venda-impressao','gpl-relatorios-comissoes','gpl-relatorio-comissionamento','impressao-pre-compra','impressao-pre-compra-dolar','impressao-compra-internacional','impressao-compra-lista','impressao-pedido-compra'], 'reports')">
      <button type="button" class="menu-link group-header"
        [class.active]="activeView === 'demonstrativo-vendas' && (collapsed() || !reportsExpanded())"
        (click)="toggleReports()" title="Relatórios">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
        </span>
        <span class="menu-label">Relatórios</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub"
        *ngIf="mostraGrupoViews(['demonstrativo-vendas','gpl-conferencia-cliente','gpl-venda-impressao','gpl-relatorios-comissoes','gpl-relatorio-comissionamento','impressao-pre-compra','impressao-pre-compra-dolar','impressao-compra-internacional','impressao-compra-lista','impressao-pedido-compra'], 'reports')">
        <button *ngIf="mostraItemView('demonstrativo-vendas', reportsExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('demonstrativo-vendas')"
          [attr.data-resource-id]="resourceId('demonstrativo-vendas')"
          [class.active]="activeView === 'demonstrativo-vendas'" (click)="navigate('demonstrativo-vendas')"
          title="Demonstrativo de Vendas">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="20" x2="18" y2="10" />
              <line x1="12" y1="20" x2="12" y2="4" />
              <line x1="6" y1="20" x2="6" y2="14" />
            </svg>
          </span>
          <span class="menu-label">Demonstrativo de Vendas</span>
        </button>
        <button *ngIf="mostraItemView('gpl-conferencia-cliente', reportsExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-conferencia-cliente')"
          [attr.data-resource-id]="resourceId('gpl-conferencia-cliente')"
          [class.active]="activeView === 'gpl-conferencia-cliente'" (click)="navigate('gpl-conferencia-cliente')"
          title="Conferencia Cliente">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 11l3 3L22 4" />
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
          </span>
          <span class="menu-label">Conferencia Cliente</span>
        </button>

        <button *ngIf="mostraItemView('gpl-venda-impressao', reportsExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-venda-impressao')"
          [attr.data-resource-id]="resourceId('gpl-venda-impressao')"
          [class.active]="activeView === 'gpl-venda-impressao'" (click)="navigate('gpl-venda-impressao')"
          title="Impressão de Venda">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9V2h12v7" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          </span>
          <span class="menu-label">Impressão de Venda</span>
        </button>
        <ng-container *ngFor="let relatorio of relatoriosCompra">
          <button *ngIf="mostraItemView(relatorio.view, reportsExpanded())" type="button"
            class="menu-link sub-link" [style.order]="ordemItem(relatorio.view)"
            [attr.data-resource-id]="resourceId(relatorio.view)" [class.active]="activeView === relatorio.view"
            (click)="navigate(relatorio.view)" [title]="relatorio.label">
            <span class="menu-icon sub-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V2h12v7"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg></span>
            <span class="menu-label">{{ relatorio.label }}</span>
          </button>
        </ng-container>
        <button *ngIf="mostraItemView('gpl-relatorios-comissoes', reportsExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-relatorios-comissoes')"
          [attr.data-resource-id]="resourceId('gpl-relatorios-comissoes')"
          [class.active]="activeView === 'gpl-relatorios-comissoes'" (click)="navigate('gpl-relatorios-comissoes')"
          title="Relatórios de Comissões">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9V2h12v7" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          </span>
          <span class="menu-label">Relatórios de Comissões</span>
        </button>
        <button *ngIf="mostraItemView('gpl-relatorio-comissionamento', reportsExpanded())" type="button"
          class="menu-link sub-link" [style.order]="ordemItem('gpl-relatorio-comissionamento')"
          [attr.data-resource-id]="resourceId('gpl-relatorio-comissionamento')"
          [class.active]="activeView === 'gpl-relatorio-comissionamento'"
          (click)="navigate('gpl-relatorio-comissionamento')" title="Relatórios de Comissionamento">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9V2h12v7" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          </span>
          <span class="menu-label">Relatórios de Comissionamento</span>
        </button>
      </div>
    </div>
    <div class="menu-group" [class.expanded]="paineisExpanded()"
      *ngIf="!emBusca() || mostraGrupo(['Separação', 'Painel de Conferência', 'Painel de Logística'])">
      <button type="button" class="menu-link group-header"
        [class.active]="(activeView === 'paineis-separacao' || activeView === 'paineis-conferencia' || activeView === 'paineis-logistica') && (collapsed() || !paineisExpanded())"
        (click)="togglePaineis()" title="Painéis">
        <span class="menu-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="3" x2="9" y2="21" />
          </svg>
        </span>
        <span class="menu-label">Painéis</span>
        <span class="menu-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div class="menu-sub" *ngIf="mostraGrupo(['Separação', 'Painel de Conferência', 'Painel de Logística'])">
        <button *ngIf="mostraItem('Separação', paineisExpanded())" type="button" class="menu-link sub-link"
          [class.active]="activeView === 'paineis-separacao'" (click)="navigate('paineis-separacao')" title="Separação">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4" />
              <polyline points="14 2 14 8 20 8" />
              <path d="M3 15h6" />
              <path d="M3 18h6" />
            </svg>
          </span>
          <span class="menu-label">Separação</span>
        </button>
        <button *ngIf="mostraItemView('paineis-conferencia', paineisExpanded())" type="button"
          class="menu-link sub-link" [class.active]="activeView === 'paineis-conferencia'"
          (click)="navigate('paineis-conferencia')" title="Painel de Conferência">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 11 12 14 22 4"></polyline>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          </span>
          <span class="menu-label">Conferência</span>
        </button>
        <button *ngIf="mostraItemView('paineis-logistica', paineisExpanded())" type="button" class="menu-link sub-link"
          [class.active]="activeView === 'paineis-logistica'" (click)="navigate('paineis-logistica')"
          title="Painel de Logística">
          <span class="menu-icon sub-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="1" />
              <path d="M16 8h4l3 4v4h-7V8z" />
              <circle cx="5.5" cy="18.5" r="2.5" />
              <circle cx="18.5" cy="18.5" r="2.5" />
            </svg>
          </span>
          <span class="menu-label">Logística</span>
        </button>
      </div>
    </div>
    </ng-container>
  </nav>

  <div class="sidebar-footer">
    <button type="button" class="menu-link logout-link" (click)="sair()" [disabled]="loggingOut()" title="Sair">
      <span class="menu-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
      </span>
      <span class="menu-label">{{ loggingOut() ? 'Saindo...' : 'Sair' }}</span>
    </button>

    <button type="button" class="menu-link manual-link" *ngIf="!collapsed()"
      [class.active]="activeView === 'gpl-manual'" (click)="navigate('gpl-manual')" title="Manual">
      <span class="menu-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.1 9a3 3 0 1 1 5.7 1.3c-.7 1.1-1.8 1.5-2.5 2.4-.3.4-.3.8-.3 1.3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </span>
    </button>
  </div>
</aside>

<!-- Barra inferior estilo aplicativo — aparece só no celular (≤ 900px) -->
<nav class="mobile-bottom-nav" aria-label="Atalhos principais">
  <button type="button" class="mbn-item" *ngIf="itemPermitidoPorView('liberacao')" [class.active]="activeView === 'liberacao'" (click)="navigate('liberacao')">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
    <span>Liberações</span>
  </button>
  <button type="button" class="mbn-item" *ngIf="itemPermitidoPorView('gpl-edicaodeprodutos')" [class.active]="activeView === 'gpl-edicaodeprodutos'" (click)="navigate('gpl-edicaodeprodutos')">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>
    <span>Edição</span>
  </button>
  <button type="button" class="mbn-item mbn-home" [class.active]="activeView === 'home'" (click)="navigate('home')">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
    <span>Home</span>
  </button>
  <button type="button" class="mbn-item" *ngIf="itemPermitidoPorView('cadastro-parceiro')" [class.active]="activeView === 'cadastro-parceiro'" (click)="navigate('cadastro-parceiro')">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
    <span>Cadastro</span>
  </button>
  <button type="button" class="mbn-item" [class.active]="!collapsed()" (click)="toggleSidebar()">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="18" x2="20" y2="18"/></svg>
    <span>Menu</span>
  </button>
</nav>
